import { BREAKOUT_NAMESPACE_ID } from "src/constants";
import { USER_ONBOARD_ACCOUNTING, USER_ONBOARD_ADMIN, USER_ONBOARD_ADMIN_ISO, USER_ONBOARD_ADMIN_UNDERWRITER, USER_ONBOARD_HIGH_CREST, USER_ONBOARD_LOAN_PROCESSOR, USER_ONBOARD_LOAN_PROCESSOR_READER, USER_ONBOARD_SALES, USER_ONBOARD_SALES_ADMIN, USER_ONBOARD_UNDERWRITER } from "src/services/constants/accounts";
import { ACCOUNT_TABS, ADMIN_TABS, ADMIN_UNDERWRITTER_TABS, HIGHREST_TABS, LOAN_PROCESSOR_READER_TABS, LOAN_PROCESSOR_TABS, SALES_TABS, UNDERWRITTER_TABS } from "./notMortgageTabs";

export const BCPipelineConfig = [{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_ADMIN,
    tabs: ADMIN_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_ADMIN_UNDERWRITER,
    tabs: ADMIN_UNDERWRITTER_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_HIGH_CREST,
    tabs: HIGHREST_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_SALES,
    tabs: SALES_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_SALES_ADMIN,
    tabs: SALES_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_ACCOUNTING,
    tabs: ACCOUNT_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_LOAN_PROCESSOR,
    tabs: LOAN_PROCESSOR_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_UNDERWRITER,
    tabs: UNDERWRITTER_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_LOAN_PROCESSOR_READER,
    tabs: LOAN_PROCESSOR_READER_TABS
},
{
    namespaceId: BREAKOUT_NAMESPACE_ID,
    role: USER_ONBOARD_ADMIN_ISO,
    tabs: ADMIN_TABS
}];


